import { ChangeDetectionStrategy, Component, input, output, viewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MenuItem } from 'primeng/api';
import { Menu } from 'primeng/menu';

import { MenuHelpers } from '../../classes/menuhelpers';

// auto: by size (over maxFileSizeMb goes to OneDrive when it can be used); device: the chat upload, as before;
// onedrive: always OneDrive
export type AttachTarget = 'auto' | 'device' | 'onedrive';

// Gap between the paperclip and the menu above it
const MENU_OFFSET_PX = 8;

/**
 * The paperclip's "Upload to OneDrive" / "Upload to chat" menu (Link-First Attachments, artboard 1). The paperclip
 * itself stays in mi-chat's composer and calls toggle(); this opens the menu above it, right-aligned, and emits the
 * choice. Both options pick files from the device - they differ only in where the files go.
 */
@Component({
  selector: 'app-attach-menu',
  templateUrl: './attach-menu.component.html',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AttachMenuComponent {
  maxFileSizeMb = input<number>(10);

  selected = output<AttachTarget>();
  openChange = output<boolean>();

  public items: MenuItem[] = [];
  private menu = viewChild<Menu>('menu');

  constructor(private translate: TranslateService) {}

  public toggle(event: Event) {
    const menu = this.menu();
    if (!menu) {
      return;
    }
    if (menu.visible) {
      menu.hide();
      return;
    }
    // Built on open so the labels follow the current locale and size limit
    this.items = [
      {
        id: 'onedrive',
        icon: 'mi2-cloud-upload',
        label: this.translate.instant('cl_chat.oneDriveUpload'),
        state: { hint: this.translate.instant('cl_chat.oneDriveUploadHint') },
        command: () => this.selected.emit('onedrive')
      },
      {
        id: 'device',
        icon: 'mi2-upload',
        label: this.translate.instant('cl_chat.uploadToChat'),
        state: { hint: this.translate.instant('cl_chat.uploadToChatHint', { size: this.maxFileSizeMb() }) },
        command: () => this.selected.emit('device')
      }
    ];
    MenuHelpers.showAbove(menu, event.currentTarget as HTMLElement, { align: 'right', gap: MENU_OFFSET_PX });
  }

  public onShow() {
    this.openChange.emit(true);
  }

  public onHide() {
    this.openChange.emit(false);
  }
}
